import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ModalAddIO extends Component {
    constructor() {
        super();

        this.state = {
            inputOutputListObj: {
                command_id0: 0,
                command_id1: 0,
                name: '',
                port_no: 0,
                port_type: '',
                val_name0: '',
                val_name1: '',
            }
        };

    }

    componentWillUnmount() {
      //
    }

    onChangeSelectedPort(e) {
        if (e.target.name === 'port') {
            const str = e.target.value;
            const res = str.split(" ");
            this.setState({ ...this.state,
                inputOutputListObj: {
                    ...this.state.inputOutputListObj,
                    port_type: res[0] === '--ไม่มี--' ? '' : res[0],
                    port_no: res[1] || ''
                }
            });
        }
    }

    onClickConfirm() {
        const { onClickConfirmAddIO } = this.props;
        const { inputOutputListObj } = this.state;
        onClickConfirmAddIO(inputOutputListObj);
    }

    render() {
        const {
            portList,
            commandList,
            onClickCancelAddIO
        } = this.props;
        return (
            <div className="modal-confirm" style={{display:'block'}} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title custom_align" id="Heading">เพิ่มข้อมูล Input/Output</h6>
                        </div>

                        <div className="modal-body">
                            <div className="form-group row">
                                <label className="col-md-3 col-form-label ">Port</label>
                                <div className="col-md-7">
                                    <select
                                        name="port"
                                        className="form-control"
                                        defaultValue= '--ไม่มี--'
                                        onChange={(e) => this.onChangeSelectedPort(e)}>
                                        <option selected>--ไม่มี--</option>
                                        {
                                            portList.map((item,key) => {
                                                return(
                                                    <option id={`port_${key}`}
                                                            selected={item.porTypeNo}
                                                            key={key}
                                                            value={item.portTypeList+' '+item.portNo}>
                                                        {item.portTypeList} {item.portNo}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                
                            </div>
                            <div className="form-group row">
                                <label className="col-md-3 col-form-label ">ชื่อ</label>
                                <div className="col-md-7">
                                    <input
                                        name="name"
                                        className="form-control"
                                        type="text"
                                        placeholder="name"
                                        onChange={(e) => this.setState({ inputOutputListObj: {...this.state.inputOutputListObj, name: e.target.value } })}
                                    />
                                </div>
                                
                            </div>
                            <div className="form-group row">
                                <label className="col-md-3 col-form-label ">ค่า 0 ชื่อ</label>
                                <div className="col-md-7">
                                    <input
                                        name="val_name0"
                                        className="form-control"
                                        type="text"
                                        placeholder="ค่า 0 ชื่อ"
                                        onChange={(e) => this.setState({ inputOutputListObj: {...this.state.inputOutputListObj, val_name0: e.target.value } })}
                                    />
                                </div>
                                
                            </div>
                            <div className="form-group row">
                                <label className="col-md-3 col-form-label ">คำสั่ง 0</label>
                                <div className="col-md-7">
                                    <select
                                        name="command_id0"
                                        className="form-control"
                                        onChange={(e) => this.setState({ inputOutputListObj: {...this.state.inputOutputListObj, command_id0: e.target.value } })} >
                                        {
                                            commandList.map((item,key) => {
                                                return(
                                                    <option id={`command_id0_${key}`}
                                                            key={`command_id0_${key}`}
                                                            value={item.command_id}>
                                                        {item.command_name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-md-3 col-form-label ">ค่า 1 ชื่อ</label>
                                <div className="col-md-7">
                                    <input
                                        name="val_name1"
                                        className="form-control"
                                        type="text"
                                        placeholder='ค่า 1 ชื่อ'
                                        onChange={(e) => this.setState({ inputOutputListObj: {...this.state.inputOutputListObj, val_name1: e.target.value } })}
                                    />
                                </div>
                                
                            </div>
                            <div className="form-group row">
                                <label className="col-md-3 col-form-label ">คำสั่ง 1</label>
                                <div className="col-md-7">
                                    <select
                                        name="command_id1"
                                        className="form-control"
                                        onChange={(e) => this.setState({ inputOutputListObj: {...this.state.inputOutputListObj, command_id1: e.target.value } })} >
                                        {
                                            commandList.map((item,key) => {
                                                return(
                                                    <option id={`command_id1_${key}`}
                                                            key={`command_id1_${key}`}
                                                            value={item.command_id}>
                                                        {item.command_name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                
                            </div>
                        </div>

                        <div className="modal-footer ">
                            {/*<button className="btn btn-primary" onClick={onClickConfirmAddIO(inputOutputListObj)} >ตกลง</button>*/}
                            <button className="btn btn-primary" onClick={() => this.onClickConfirm()} >ตกลง</button>
                            <button className="btn btn-danger" onClick={onClickCancelAddIO}  >ยกเลิก</button>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
            </div>
        )
    }
}

ModalAddIO.propTypes = {
    portList: PropTypes.array.isRequired,
    commandList: PropTypes.array.isRequired,
    onClickCancelAddIO: PropTypes.func.isRequired,
    onClickConfirmAddIO: PropTypes.func.isRequired
    // onClickCancelChangePassword: PropTypes.func.isRequired
}

export default ModalAddIO



// WEBPACK FOOTER //
// ./src/app/view/Modals/ModalAddIO.js